import { Aggregations } from '../../../models/Aggregations';
import { ProductFilter } from '../../../models/Product';

export const markEmptyAggregations = (data: Aggregations, filterMap: ProductFilter): Aggregations => {
    return Object.entries(data).reduce((all, [key, value]) => {
        return {
            ...all,
            [key]: {
                ...value,
                buckets: value.buckets ? value.buckets : key in filterMap ? [] : undefined
            }
        };
    }, {});
};
